import React from "react";
import { useMenuLanguage } from "../../context/MenuLanguageContext";
import { useTranslation } from "react-i18next";

const MobileSwitchLanguage: React.FC = () => {
  const { i18n } = useTranslation();
  const { menuLanguageIsVisible, toggleMenuLanguage } = useMenuLanguage();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    toggleMenuLanguage();
  };

  const {t} = useTranslation();

  return (
    <div>
      <li onClick={toggleMenuLanguage}>
        <button className="flex justify-center items-center gap-8">
          <span>{t("header.langue")}</span>
          <img
            src="assets/images/vecteurs/chevron-right.svg"
            alt="chevron"
            className="w-4"
          />
        </button>
      </li>
      <div
        className={`absolute flex px-4 flex-row bg-white top-0 left-0 ${
          menuLanguageIsVisible ? "h-full" : "h-0"
        } overflow-hidden duration-300 w-full`}
      >
        <ul>
          <li onClick={toggleMenuLanguage}>
            <button className="mt-2 ml-2">
              <img
                src="/assets/images/vecteurs/arrow-left.svg"
                alt="arrow left"
                className="w-12"
              />
            </button>
          </li>
          {/* Option en anglais */}
          <li
            className="px-4 rounded-md py-3 mb-4 flex gap-2 items-center hover:bg-gray-200 cursor-pointer"
            onClick={() => changeLanguage("en")}
          >
            <img
              src="/assets/images/vecteurs/18166.jpg"
              alt="flag"
              width="25"
            />
            <span>English</span>
          </li>

          {/* Option en français */}
          <li
            className="px-4 py-3 rounded-md flex gap-2 items-center hover:bg-gray-200 cursor-pointer"
            onClick={() => changeLanguage("fr")}
          >
            <img
              src="/assets/images/vecteurs/france.WEBP"
              alt="flag"
              width="25"
            />
            <span>Français</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileSwitchLanguage;
